module.exports = __webpack_public_path__ + "img/desire_002.7f9230d.png";